import {
  AggregationType,
  aggregationTypes,
  AxisSettings,
  chartTypes,
  GlobalSettings,
  lineStyles,
} from '@twaice-fe/shared/models';

export function unmarshalGlobalSettings(globalSettings: string): GlobalSettings {
  const settingsArray = globalSettings.split(';');
  const chartMode = settingsArray[0] === 'st' ? 'stacked' : 'single';
  const groupBy = settingsArray[1] === 's' ? 'sensor' : 'unit';
  const dataType = settingsArray.length > 2 && settingsArray[2] === 'a' ? 'all' : 'cleansed';
  return { chartMode, groupBy, dataType };
}

export function unmarshalAxisSettings(axisSettings: string[]): AxisSettings[] {
  const axisSettingsResult: AxisSettings[] = [];
  if (!axisSettings || axisSettings.length === 0) {
    return axisSettingsResult;
  }
  axisSettings.forEach((axisSettingsString) => {
    const axisSettingsArray = axisSettingsString.split(';');
    const chartType = chartTypes.find((type) => type.code === axisSettingsArray[3]).value || 'line';
    const displayDataPoints = axisSettingsArray[4] === '1';
    const aggregationType = aggregationTypes.find((type) => type.code === axisSettingsArray[5]).value || AggregationType.AVG;
    const zeroYAxis = axisSettingsArray[6] === '1';
    // Fallback for older settings
    if (!axisSettingsArray[7]) {
      axisSettingsArray[7] = 'l';
    }
    const lineStyle = lineStyles.find((type) => type.code === axisSettingsArray[7]).value || 'linear';
    // Fallback for older settings saved before scalingFactor was persisted, and for malformed values
    const parsedScalingFactor = Number(axisSettingsArray[8]);
    const scalingFactor = axisSettingsArray[8] === undefined || Number.isNaN(parsedScalingFactor) ? 1 : parsedScalingFactor;

    axisSettingsResult.push({
      key: axisSettingsArray[0] === 'undefined' ? undefined : axisSettingsArray[0],
      name: axisSettingsArray[1],
      unit: axisSettingsArray[2],
      scalingFactor,
      chartType,
      lineStyle,
      displayDataPoints,
      aggregationType,
      zeroYAxis,
      open: false,
    });
  });
  return axisSettingsResult;
}
